import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/orderLog/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/orderLog/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/orderLog/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/orderLog/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/orderLog/delete/batch', {
    params: {
      ids
    }
  })
}
